import { render, staticRenderFns } from "./Asset-Service-Detail.vue?vue&type=template&id=81b399d6"
import script from "./Asset-Service-Detail.vue?vue&type=script&lang=js"
export * from "./Asset-Service-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports